// extracted by mini-css-extract-plugin
export default {"table":"Orders_table__QsGTf","icons":"Orders_icons__zr1o6","pending":"Orders_pending__igXKg","delivered":"Orders_delivered__oq-jy"};